import React, { useState } from 'react';


const ProductItem = props => {
  const { product } = props;
  const [count, setCount] = useState(1);
  const [btnText, setBtnText] = useState("Add to Cart");
  const [option, setOption] = useState(product.description? product.description.split(",")[0] : "");
  
      
  function increase() { setCount(count+1) }
  function decrease() { if(count>0)setCount(count-1) }
  function reset() { setCount(1) }
    
  function add() {
      if(product.description.trim() !="" && option == ""){
          setOption(product.description.split(",")[0])
          console.log("option set")
      }
      
      //Add the selected option if such exists
      if(option){
//          product.name = product.name + "( " + option + " )";
          //clone the object and 
          console.log("Product: " + JSON.stringify(product))
          let newProd = {
              "id":product.id + "( " + option + " )",
              "name":product.name + " ( " + option + " )",
              "stock":9999,
              "price":product.price,
              "shortDesc":product.shortDesc, 
              "description":product.description,
              "imageUrl":product.imageUrl
          }
          
          props.addToCart({
            id: newProd.name, 
            product: newProd,
            amount: count
          });
      }else{
          props.addToCart({
            id: product.name,
            product,
            amount: count
        });
      }
      setCount(1);
      setBtnText("Added")
      setTimeout(function() {
           setBtnText("Add to Cart")
        }, 2000);
  }
    
  function handleSelect(event){
//      setOption(event.target.value)
//      console.log("selected set: " + event.target.value)
      setOption(event.target.value)
  }

    
        
  function handleTextChange(e) {
      if(e.target.name == "number") setCount(e.target.value)
////      console.log(JSON.parse(JSON.stringify(product.description)));
//      let ars = JSON.parse(JSON.stringify(product.description).split(','));
//      console.log("item: " + product.description.split(",")[1])
  }
    
  return (
    <div className=" column is-half">
      <div className="box">
        <div className="media">
          <div className="media-left">
            <figure className="image is-64x64">
              <img
                src={product.imageUrl}
              />
            </figure>
          </div>
          <div className="media-content">
            <b style={{ textTransform: "capitalize" }}>
              {product.name}{" "}
              <span className="tag is-primary">${product.price}</span>
            </b>
            <div>{product.shortDesc}</div>
            {/*product.stock > 0 ? (
              <small>{product.stock + " Available"}</small>
            ) : (
              <small className="has-text-danger">Out Of Stock</small>
            )*/}
            { product.description.trim() !="" ? (
                <select onChange={handleSelect}>
                    {
                        product.description.split(",").map((item)=> 
                            (<option key={'"' + item + '"'}>{item}</option>))
                    }

              </select>
                ):("")
            }
            <div className="is-clearfix">
                
                <br></br>
                   <h1>How many to add: {count}</h1>
                   
                <input
                  style={{width: "60px"}}
                  className="input"
                  type="number"
                  name="number"
                  value={count}
                  onChange={handleTextChange}
                />
                   {/* <button style={{margin:2}} className='decrement button is-outlined is-primary' onClick={decrease} >-</button>
                    <button style={{margin:2}} className='increment button is-outlined is-primary' onClick={increase} >+</button>
      <button style={{margin:2}} className='reset button is-outlined is-primary' onClick={reset} >x</button>*/}
                    
              <button style={{padding:5}} className=" button is-outlined is-primary   is-pulled-right"
                onClick={add}
              >
                {btnText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductItem;
